export default function getFileExtension(fileName) {
  const dotIndex = fileName.lastIndexOf(".");

  return dotIndex === -1 || dotIndex === 0 ? null : fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length);
}
